import { TENANTS } from "../../../../../constants"
import { loc } from "../../../../../core/utils"
import { any, string } from "prop-types"
import React from "react"
import { Col, Row } from "react-bootstrap"

export default function NotFinanceableInsurances({ notFinanceableInsuranceList, formattedAmount, tenant }) {
  const nullValues = ["null", "0"]
  const hideFormattedAmount = nullValues.some((nullValue) => formattedAmount?.includes(nullValue))
  if (formattedAmount && !hideFormattedAmount) {
    if (tenant === TENANTS.MORTAR) {
      return (
        <Row>
          <Col>
            <p>
              <small>{loc("including insurance at")}</small>
            </p>
          </Col>
          <Col>
            <p className="text-right">
              <small>{formattedAmount}</small>
            </p>
          </Col>
        </Row>
      )
    }
    return notFinanceableInsuranceList?.map((insurance, index) => (
      <Row key={insurance + index}>
        <Col>
          <p>
            <small>{loc("including insurance at")}</small>
          </p>
        </Col>
        <Col>
          <p className="text-right">
            <small>{formattedAmount || insurance}</small>
          </p>
        </Col>
      </Row>
    ))
  } else {
    return null
  }
}

NotFinanceableInsurances.propTypes = {
  notFinanceableInsuranceList: any,
  formattedAmount: string
}
